import { Component, OnInit } from '@angular/core';
import { EmergencyCalls } from '../../models/emergency-calls';
import { EmergencyCallsService } from '../../services/emergency-calls-service';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-emergency-calls',
  templateUrl: './add-emergency-calls.component.html',
  styleUrls: ['./add-emergency-calls.component.scss']
})
export class AddEmergencyCallsComponent implements OnInit {

    model = {} as EmergencyCalls;
    isEdit = false;
    isLoading: boolean = false;

    constructor(
      private service: EmergencyCallsService,
      private diagRef: NbDialogRef<AddEmergencyCallsComponent>,
      private toast: NbToastrService,
      private route : Router
    ) {}

    ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
    }

    save(){
      this.isLoading = true;
      this.service.post(this.model).subscribe((res) => {
        this.isLoading = false;
        this.diagRef.close('true');
        this.toast.show('تم الإضافة بنجاح', '', { status: 'success', duration: 3000 });
      });
    }

    update(){
      this.isLoading = true;
      this.service.put(this.model.id, this.model).subscribe((res) => {
        this.isLoading = false;
        this.diagRef.close('true');
        this.toast.show('تم التعديل بنجاح', '', { status: 'success', duration: 3000 });
      });
    }

    close() {
      this.diagRef.close();
    }


}
